(function ($, Drupal) {
  'use strict';

  if ('objectFit' in document.documentElement.style === false) {
    Drupal.behaviors.frontendObjectFit = {
      attach: function (context) {
        $('picture img', context)
          .each(updateBackgroundImage)
          .on('load', updateBackgroundImage)
          .css('opacity', 0);
      }
    };
  }

  function updateBackgroundImage() {
    if (this.complete) {
      $(this).each(function (i, obj) {

        // IE fix: als URL background gezet wordt, werd de focal point data niet meer gebruikt.
        var $focalX = $(obj).attr('data-focal-x') * 10;
        var $focalY = $(obj).attr('data-focal-y') * 10;
        if ($focalX !== null && $focalY !== null) {
          $(obj).closest('picture').css('background-position-x', $focalX + '%');
          $(obj).closest('picture').css('background-position-y', $focalY + '%');
        }

        $(obj).closest('picture').css('background-image', 'url(' + (obj.currentSrc || obj.src) + ')');
      });
    }
  }

})(jQuery, Drupal);
